import { BritishColumbiaObstetricalFileClickableTextContext } from "@/Common/Models/UI/ClickableTextContext";
import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";

class BritishColumbiaObstetricalPrenatalGeneticInvestigation extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private readonly PrenatalGeneticInvestigations_OtherId = "Section13_PrenatalGeneticInvestigations_Other";
    private readonly PrenatalGeneticInvestigations_ResultId = "Section13_PrenatalGeneticInvestigations_ResultId";

    public render(): JSX.Element {
        const prenatalGenetic = this.props.form.Section13.PrenatalGenetic;

        return (
            <div className="section">
                <div className="row row-form">
                    <div className="col-md-12 bc-antenatal-part2">
                        <div className="flex-display flex-col-gap-sm">
                            <div className="flex-col-gap-sm" style={{ width: "80%" }}>
                                <div className="flex-display flex-col-gap-sm">
                                    <div className="bold width-40">{this.getString("ObstetricalFile_PrenatalGeneticInvestigationsLabel")}</div>
                                    {this.controlRenderer.renderCheckbox(
                                        "DeclinedLabel",
                                        prenatalGenetic.Declined,
                                        value => this.props.mutateModelStateWithFormUpdate(s => s.Section13.PrenatalGenetic.Declined = value)
                                    )}
                                </div>
                                <div className="flex-display flex-col-gap-sm">
                                    <div className="flex-display width-40">
                                        {this.controlRenderer.renderCheckbox(
                                            "SerumIntegratedPrenatalScreenAbbrevLabel",
                                            prenatalGenetic.SerumIntegratedPrenatalScreen,
                                            value => this.props.mutateModelStateWithFormUpdate(s => s.Section13.PrenatalGenetic.SerumIntegratedPrenatalScreen = value),
                                            "col-md-6 padding-none-left"
                                        )}
                                        {this.controlRenderer.renderCheckbox(
                                            "IntegratedPrenatalScreenAbbrevLabel",
                                            prenatalGenetic.IntegratedPrenatalScreen,
                                            value => this.props.mutateModelStateWithFormUpdate(s => s.Section13.PrenatalGenetic.IntegratedPrenatalScreen = value)
                                        )}
                                    </div>
                                    <div className="width-40">
                                        {this.controlRenderer.renderCheckbox(
                                            "QuadLabel",
                                            prenatalGenetic.Quad,
                                            value => this.props.mutateModelStateWithFormUpdate(s => s.Section13.PrenatalGenetic.Quad = value)
                                        )}
                                    </div>
                                    <div style={{ width: "15%" }}>
                                        {this.controlRenderer.renderCheckbox(
                                            "ChorionicVillusSamplingAbbrevLabel",
                                            prenatalGenetic.ChorionicVillusSampling,
                                            value => this.props.mutateModelStateWithFormUpdate(s => s.Section13.PrenatalGenetic.ChorionicVillusSampling = value)
                                        )}
                                    </div>
                                </div>
                                <div className="flex-display flex-col-gap-sm">
                                    <div className="flex-display width-40 prenatal-genetic-investigation">
                                        {this.controlRenderer.renderCheckbox(
                                            "NonInvasivePrenatalTestingMedicalServicePlanAbbrevLabel",
                                            prenatalGenetic.NonInvasivePrenatalTestingMedicalServicePlan,
                                            value => this.props.mutateModelStateWithFormUpdate(s => s.Section13.PrenatalGenetic.NonInvasivePrenatalTestingMedicalServicePlan = value),
                                            "col-md-6 padding-none-left"
                                        )}
                                        {this.controlRenderer.renderCheckbox(
                                            "NonInvasivePrenatalTestingAbbrevLabel",
                                            prenatalGenetic.NonInvasivePrenatalTesting,
                                            value => this.props.mutateModelStateWithFormUpdate(s => s.Section13.PrenatalGenetic.NonInvasivePrenatalTesting = value)
                                        )}
                                    </div>
                                    {this.renderRadioCheckboxWithLabel(
                                        "Section13_PrenatalGeneticInvestigations_Other",
                                        "ObstetricalFile_OtherLabel",
                                        prenatalGenetic.Other.Value,
                                        value => {
                                            this.props.mutateModelState(
                                                s => s.Section13.PrenatalGenetic.Other.Value = value,
                                                () => {
                                                    this.props.handleFormUpdate();
                                                    this.setFocusTextbox(value, this.PrenatalGeneticInvestigations_OtherId);
                                                }
                                            );
                                        },
                                        this.getAdditionalTextBox({
                                            id: this.PrenatalGeneticInvestigations_OtherId,
                                            value: prenatalGenetic.Other.Description,
                                            onChange: value => this.props.mutateModelState(s => s.Section13.PrenatalGenetic.Other.setDescriptionAndCheckbox(value)),
                                            valueClassName: "margin-xs-left",
                                            maxLength: this.page2FieldLimits.Section13_PrenatalGeneticInvestigations_OtherComments.MaxChars,
                                            valueStyle: { textAlign: "left" }
                                        }),
                                        true,
                                        "width-40"
                                    )}
                                    <div className="prenatal-genetic-investigation" style={{ width: "15%" }}>
                                        {this.controlRenderer.renderCheckbox(
                                            "AmniocentesisAbbrevLabel",
                                            prenatalGenetic.Amniocentesis,
                                            value => this.props.mutateModelStateWithFormUpdate(s => s.Section13.PrenatalGenetic.Amniocentesis = value)
                                        )}
                                    </div>
                                </div>
                            </div>
                            {this.renderField({
                                label: "ResultsLabel",
                                field: this.controlRenderer.renderTextarea({
                                    id: this.PrenatalGeneticInvestigations_ResultId,
                                    value: prenatalGenetic.Results,
                                    onChange: value => this.props.mutateModelState(s => s.Section13.PrenatalGenetic.Results = value),
                                    maxLength: this.page2FieldLimits.Section13_Results.MaxChars,
                                    maxRows: this.page2FieldLimits.Section13_Results.MaxRows,
                                    clickableTextOptions: this.props.getClickableTextOptions(this.PrenatalGeneticInvestigations_ResultId, BritishColumbiaObstetricalFileClickableTextContext.Section13_PrenatalInvestigationResult, true),
                                    className: "textarea-padding"
                                })
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { BritishColumbiaObstetricalPrenatalGeneticInvestigation };
